import { Base } from '@studiometa/js-toolkit';

/**
 * Delivery date calculator class.
 */
export default class DeliveryDate extends Base {
  static config = {
    name: 'DeliveryDate',
    refs: ['standardDeliveryDate'],
    options: {
      days: {
        type: Number,
        default: 2,
      },
    },
  };

  static FRENCH_PUBLIC_DAYS = [
    '01-01',
    '05-01',
    '05-08',
    '07-14',
    '08-15',
    '11-01',
    '11-11',
    '12-25',
  ];

  /**
   *
   */
  mounted() {
    this.currentDate = new Date();
    this.calculateStandardDeliveryDate();
  }

  /**
   * Fonction pour calculer la date de livraison standard.
   * @param {number} days
   * @returns {void}
   */
  calculateStandardDeliveryDate(days = null) {
    const openDays = days ?? this.$options.days;
    const maxDays = openDays + 2;

    const minDate = DeliveryDate.calculateDeliveryDate(this.currentDate, openDays);
    const maxDate = DeliveryDate.calculateDeliveryDate(this.currentDate, maxDays);

    const minDateStr = this.getLocalDateString(minDate);
    const maxDateStr = this.getLocalDateString(maxDate);

    this.$refs.standardDeliveryDate.innerHTML = `Livraison estimée entre ${minDateStr} et le ${maxDateStr}`;

    this.$el.classList.remove('hidden');
  }

  /**
   * @param {Date} deliveryDate
   * @returns {string}
   */
  getLocalDateString(deliveryDate) {
    return deliveryDate.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'short',
    });
  }

  /**
   * Max days in a month
   * @param {number} month From 1 to 12
   * @param {number} year
   * @returns {"28" | "29" | "30" | "31"}
   */
  static getMaxMonthDays(month, year) {
    if ([1, 3, 5, 7, 8, 10, 12].includes(month)) {
      return 31;
    }

    if (month === 2) {
      return year % 4 === 0 ? 29 : 28;
    }

    return 30;
  }

  /**
   * Calculate delivery date.
   * For performance reasons, use this method rather than instantiating Date several times.
   * @param {Date} currentDate
   * @param {number} openDays
   * @returns {Date}
   */
  static calculateDeliveryDate(currentDate, openDays) {
    let loopDate = currentDate.getDate();
    let loopDay = currentDate.getDay();
    let loopMonth = currentDate.getMonth() + 1;
    let loopYear = currentDate.getFullYear();
    let loopMaxMonth = DeliveryDate.getMaxMonthDays(loopMonth, loopYear);
    let loopOpenDays = openDays;

    for (let i = 1; i <= loopOpenDays; i += 1) {
      loopDate += 1;
      loopDay = loopDay < 6 ? loopDay + 1 : 0;

      if (loopDate > loopMaxMonth) {
        loopDate = 1;
        loopMonth = loopMonth < 12 ? loopMonth + 1 : 1;
        loopYear = loopMonth !== 1 ? loopYear : loopYear + 1;
        loopMaxMonth = DeliveryDate.getMaxMonthDays(loopMonth, loopYear);
      }

      const monthDay = `${loopMonth > 9 ? loopMonth : `0${loopMonth}`}-${
        loopDate > 9 ? loopDate : `0${loopDate}`
      }`;

      if ([0, 6].includes(loopDay) || DeliveryDate.FRENCH_PUBLIC_DAYS.includes(monthDay)) {
        loopOpenDays += 1;
      }
    }

    const monthDay = `${loopMonth > 9 ? loopMonth : `0${loopMonth}`}-${
      loopDate > 9 ? loopDate : `0${loopDate}`
    }`;

    return new Date(`${loopYear}-${monthDay}`);
  }
}
